import React, { useState } from 'react';
import css from './FilterSidebar.module.css';
import { FormattedMessage } from 'react-intl';
import FilterSectionHeader from './FilterSectionHeader';
import { Icons } from '../../../components';

const AgencyFilterSection = ({ handleClearFilter, updateURLParams, selectedValue, paramKey }) => {
  const [agencyText, setAgencyText] = useState(selectedValue || '');
  const handleApply = () => {
    updateURLParams(paramKey, [agencyText]);
    setAgencyText('');
  };
  const handleClear = () => {
    handleClearFilter(paramKey);
    setAgencyText('');
  };
  return (
    <div className={css.agencyFilterContainer}>
      <FilterSectionHeader titleId={'FilterCategories.agency'} handleClear={handleClear} />

      <div className={css.agencyInputWrapper}>
        <div className={css.searchKeywordSec}>
          <button onClick={handleApply} className={css.agencyApplyButton}>
            <Icons name="search" className={css.searchIcon} />
          </button>
          <input
            type="text"
            className={css.agencyTextInput}
            value={agencyText}
            placeholder="Enter Agency Name"
            onChange={e => setAgencyText(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default AgencyFilterSection;
